<!--
* 组件名 : 右图左字的绘画图
* 开发者 : JY
*
* 参数:
*  data     { String }   required - 图片墙卡片信息
*
* 事件:     
* itemClick  []  -  点击图片打开图片管理器
* 
* 
-->

<template>
  <section class="v-float-image-content" ref="wrap">
    <div class="sticky-content d-flex">
      <div class="left-text-float-box" ref="leftTextFloatBox">
        <div class="float-text set-font-size" v-html="data" ref="textContent" />
      </div>
      <div class="right-image-float-box" ref="rightImageFloatBox">
        <v-float-image
          :image="imgSrc"
          :maxImage="maxImgSrc"
          :desc="imageInfo"
          :slug="slug"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { getPaintImagePath } from "utils/util";
import vFloatImage from "./components/image-viewer/index.vue";

export default {
  name: "v-float-image-content",
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  components: {
    vFloatImage,
  },
  data() {
    return {
      imgSrc: "",
      maxImgSrc: "",
      imageInfo: "",
      slug: "",
    };
  },
  mounted() {
    this.find_paint_info();
    // this.sticky_count();
  },
  methods: {
    /**
     *  匹配图片，找出图解文字
     */
    find_paint_info() {
      $(this.$refs.wrap)
        .find(".float-image-item")
        .map((index, el) => {
          let imgLink = getPaintImagePath(el.dataset.slug);

          el.dataset.min = imgLink.min;
          el.dataset.max = imgLink.max;
          this.maxImgSrc = el.dataset.max;
          this.imgSrc = imgLink.min;
          this.slug = el.dataset.slug;

          //  找出图解文字
          this.imageInfo = $(el)
            .find(".imageInfo")
            .html();

          $(el)
            .find(".imageInfo")
            .remove();
        });
    },
    /**
     * 判断是否悬浮
     */
    sticky_count() {
      $(this.$refs.textContent).map((i, item) => {
        let textBoxHeight = $(item)
          .find(".float-image-item")
          .outerHeight();
        if (textBoxHeight - 10 > window.innerHeight) {
          $(item)
            .parents(".sticky-content")
            .addClass("is_sticky");
        }
      });
    },
  },
};
</script>

<style lang="scss">
.v-float-image-content {
  padding: 120px 0 100px 0;
  margin: auto;

  .sticky-content {
    justify-content: center;

    .v-float-image {
      position: sticky;
      left: 0;
      top: 15%;
    }

    // &.is_sticky {
    //   align-items: normal;
    // }
  }

  .left-text-float-box {
    width: 34.3%;
    margin-right: 82px;

    .float-text {
      height: 100%;
      @include flex(center);
    }

    .float-image-item {
      p {
        font-size: var(--font-size);
        line-height: 1.8;
        transform: translateZ(0);
      }
    }
  }

  .right-image-float-box {
    width: 47.1%;
    position: relative;
  }

  //  IE11
  @media all and (-ms-high-contrast: none) {
    .right-image-float-box {
      @include flex(center);
    }
  }

  @media (min-width: $lx-min) {
    .sticky-content {
      &.is_sticky {
        .v-float-image {
          top: 21%;
        }
      }
    }
  }

  @media (min-width: $lx-max) {
    max-width: 1684px;

    .left-text-float-box {
      margin-right: 118px;
    }
  }
}

body[data-lang="zh-TW"],
body[data-lang="zh-CN"] {
  .v-float-image-content {
    .float-image-item p {
      text-indent: 2em;
    }
  }
}
</style>
